var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            _vm._l(_vm.categories, function (item, index) {
              return _c(
                "v-card",
                {
                  key: index,
                  staticClass: "trip-category mb-2 pa-2",
                  attrs: { outlined: "" },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "", align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "2" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: "Category",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                              clearable: "",
                              items: _vm.selectableCategories,
                              "item-text": "name",
                              "item-value": "category_key",
                            },
                            model: {
                              value: _vm.categories[index].category_key,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.categories[index],
                                  "category_key",
                                  $$v
                                )
                              },
                              expression: "categories[index].category_key",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass: "text-right",
                          attrs: { cols: "12", sm: "10" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: "Move up",
                                disabled: index === 0,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveUp(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_upward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                title: "Move down",
                                disabled: index === _vm.categories.length - 1,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.moveDown(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("arrow_downward")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ies-coral--text",
                              attrs: { icon: "", small: "", title: "Delete" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(index)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "text-right",
              attrs: { cols: "12", sm: "3", "offset-sm": "9" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ies-green",
                  attrs: { title: "Add Category" },
                  on: {
                    click: function ($event) {
                      return _vm.addItem()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: this.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }